import { Outlet } from "react-router"
import { RedirectIfAuthenticated } from "../../Auth"

export default function Layout() {
	return (
		<RedirectIfAuthenticated>
			<Outlet />
		</RedirectIfAuthenticated>
	)
}
